function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { $uniUP } from "../..";
// title="Tipos de catálogo" open="left"
export var SidebarManagerController = /*#__PURE__*/function () {
  SidebarManagerController.$inject = ["$log", "NotifService"];
  function SidebarManagerController($log, NotifService) {
    _classCallCheck(this, SidebarManagerController);
    this.$log = $log;
    this.NotifService = NotifService;
  }
  return _createClass(SidebarManagerController, [{
    key: "$onInit",
    value: function $onInit() {
      this.sidebars = {};
    }
  }, {
    key: "getSidebar",
    value: function getSidebar(key) {
      var s = this.sidebars[key];
      return s || this.NotifService.aviso("Sidebar no encontrado") || null;
    }
  }, {
    key: "registraSidebar",
    value: function registraSidebar(key, sidebar) {
      this.sidebars[key] = sidebar;
    }
  }, {
    key: "togglePanel",
    value: function togglePanel(panelKey) {
      console.log("abrirPanel ".concat(panelKey, " ****"));

      // this.onPanelEmpresas()

      var sidebarInstance = this.getSidebar(panelKey);
      this.$log.info("sidebar AVISOS", sidebarInstance);
      sidebarInstance && sidebarInstance.toggle();
    }
  }]);
}();

/**
 * Panel lateral de acceso rápido a los tipos de catálogo
 */
$uniUP.component("sidebarManager", {
  bindings: {},
  controller: SidebarManagerController
  // transclude: true,
  // template : "<ng-transclude></ng-transclude>"
});